import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js';
import {Model} from 'backbone';
import util         from 'util/Util.js';
import nameTemplate from 'properties/main/form-name.ejs';
import listService      from 'ListService.js';
import _ from 'lodash';
import constants from 'Constants.js';
import AlertDialogView from 'common-views/AlertDialogView.js';
import AccountService from 'AccountService.js';
import formModel        from 'formModel.js';

class MainFormNameView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'  : 'getFocus',
            'click #isResponsive': 'updateResponsive'
        };
        this.model.set('responsiveActive', '', {silent: true});
        // PF-2909: Retrieving the value stored from the load service, to complete title/name logic
        // whenever there's not a title set up in the player,
        // the form name is being used as title
        //this.model.set('name', this.model.get('name'), {silent: true});

        if ( util.isEmpty(this.model.get('title')) ) {
            this.model.set('title', this.model.get('name'), {silent: true});
        }
        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));

        if(propName === "name"){
            util.setAppNewName(propVal);
        }
        this.model.set( propName, propVal );

        if (listService.mainKind === 'M') {
            listService.setDirty();
        }
    }

    updateResponsive(ev){

        AccountService.verifyResponsive().then((hasResponsive) => {
            const currentForm = listService.currentForm;
            if(hasResponsive){
                const checkbox = ev.currentTarget;
                const responsive = checkbox.checked ? true : false;
                const currentFormModel = _.get(listService, 'currentForm.model');
                if(currentFormModel) {
                    currentFormModel.set('responsive', responsive);
                }
            } else {
                ev.preventDefault();
                const
                    alertText = constants.MSG_RESPONSIVE_DENIED,
                    alertTitle = constants.TITLE_ENABLE_RESPONSIVE,
                    alertVIew = new AlertDialogView({model: new Model({text: alertText, title: alertTitle, parent: this.$el})});

                alertVIew.render();
            }
        });

    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));

            const currentFormModel = _.get(listService, 'currentForm.model');
            if(currentFormModel && util.isTrue(currentFormModel.get('responsive'))) {
                //this.listenTo(listService.currentForm.model, 'change', this.render);
                $(constants.RESPONSIVE_CHECKBOX_ID).attr('checked', true);
            }

        }

        this.addMultilanguageIcon();
        this.delegateEvents();
        return this;
    }

}

export default MainFormNameView;
